import { GROUPS_FETCHED } from "../actions/driverPrizesTable";

export default (state = null, action = {}) => {
  switch (action.type) {
    case GROUPS_FETCHED:
      return action.payload;

    default:
      return state;
  }
};
